import { Paper } from '@mui/material';
import { ReactNode } from 'react';
import { colorTheme } from '@styles/muiTheme';

interface LenderUtilityGridItemProps {
    children: ReactNode;
    direction?: string;
    align?: string;
    justify?: string;
}

export const LenderUtilityGridItem = ({ children, direction = 'row', align = 'center', justify = 'space-evenly' }: LenderUtilityGridItemProps) => (
    <Paper 
        elevation={4} 
        square={false}
        sx={{ 
            display: 'flex',
            flexDirection: direction,
            justifyContent: justify,
            alignItems: align,
            border: `${colorTheme.palette.success.main} 2px solid`, 
            backgroundColor: colorTheme.palette.background.paper,
            boxShadow: `0px 4px 12px ${colorTheme.palette.primary.dark}`,
            padding: 2,
        }}>
            {children}
    </Paper>
  );